export default __webpack_public_path__ + "static/DSC_0422-f6ecbfffd277e71e10f49d72783df7dd.jpg";